// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"62cf1228","26":"f6cfa003","67":"ca7b0eab","203":"2ee8b8dd","292":"f4e6a285","351":"2ae728c7","453":"fc1357e5","711":"e428bf39","822":"317c742a","919":"bb272a02"}[chunkId] + ".chunk.js";
};